import React, { useState, useEffect } from "react";
import { Card, Row, Col, Button, Form } from "react-bootstrap";
import "./EventDetailsForm.css";
import { useSelector, useDispatch } from "react-redux";
import {
  ShowAllCategories,
  ShowAllServiceLocation,
} from "../../../context/Slice/VendorManagementSlice";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import { Slider, Typography } from "@mui/material";
import CategorySelectionComponent from "./CategorySelectionComponent";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const predefinedDetailsMap = {
  Event: [
    { type: "caterers", price: "" },
    { type: "Decoration", price: "" },
    { type: "Venue", price: "" },
    { type: "Music", price: "" },
  ],
};

// Function to convert numbers to words
function numberToWords(num) {
  const a = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];
  const b = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  if (num === 0) return "zero";

  let words = "";

  if (Math.floor(num / 10000000) > 0) {
    words += numberToWords(Math.floor(num / 10000000)) + " crore ";
    num %= 10000000;
  }

  if (Math.floor(num / 100000) > 0) {
    words += numberToWords(Math.floor(num / 100000)) + " lakh ";
    num %= 100000;
  }

  if (Math.floor(num / 1000) > 0) {
    words += numberToWords(Math.floor(num / 1000)) + " thousand ";
    num %= 1000;
  }

  if (Math.floor(num / 100) > 0) {
    words += numberToWords(Math.floor(num / 100)) + " hundred ";
    num %= 100;
  }

  if (num > 0) {
    if (words !== "") words += "and ";
    if (num < 20) words += a[num];
    else {
      words += b[Math.floor(num / 10)];
      if (num % 10 > 0) words += "-" + a[num % 10];
    }
  }

  // Remove 'rupees' from the middle
  words = words.replace(/ rupees /g, " ");

  // Append 'rupees' at the end
  return words.trim() + (words.trim() !== "zero" ? " rupees" : "");
}

const UpdateEventDetails = ({ category, onClose }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const categories =
    useSelector((state) => state.VendorManagementR.AllCat) || [];
  const locations = useSelector((state) => state.VendorManagementR.AllLoc);
  // console.log("locations", locations);

  useEffect(() => {
    dispatch(ShowAllCategories());
    dispatch(ShowAllServiceLocation());
  }, [dispatch]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [eventDetails, setEventDetails] = useState([]);
  const [selectedField, setSelectedField] = useState("");
  const [Budget, setBudget] = useState(null);
  const [TotBudget, setTotBudget] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    eventName: "",
    eventBudget: "",
    guestCount: "",
    startDate: "",
    endDate: "",
    description: "",
    proposedDate: "",
    preferencesLanguage: "",
  });

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 600);
  useEffect(() => {
    // Assuming the event ID or other unique identifier is available to fetch the event data
    const fetchEventData = async () => {
      const accessToken = localStorage.getItem("token");
      if (!accessToken) {
        alert("Access token is missing. Please log in again.");
        navigate("/login"); // Redirect to login page
        return;
      }

      try {
        // Fetch event data from the backend
        const response = await axios.get(
          `${BASE_URL}/api/v1/user/budget-tool`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        // Assuming the response contains the event data
        const eventData = response.data;

        // Set form data
        setFormData({
          eventName: eventData.eventName,
          startDate: eventData.startDate,
          endDate: eventData.endDate,
          description: eventData.description,
          proposedDate: eventData.proposedDate,
          eventPreferencesLocations: eventData.eventPreferencesLocations,
          email: eventData.email,
          mobile_number: eventData.mobile_number,
          guestCount: eventData.guestCount,
          eventBudget: eventData.eventBudget,
          estimatedBudget: eventData.estimatedBudget,
          budgetCategories: eventData.budgetCategories,
          preferencesLanguage: eventData.preferencesLanguage,
        });

        // Set event details (this assumes that the backend sends the event categories with prices)
        setEventDetails(eventData.budgetCategories || []);
      } catch (error) {
        console.error("Error fetching event data:", error);
        alert("Failed to fetch event data. Please try again.");
      }
    };

    fetchEventData();
  }, []);
  console.log(categories);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 600);
    };

    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    setEventDetails(predefinedDetailsMap[category] || []);
  }, [category]);

  const handleChange = (e, index, field) => {
    const { value } = e.target;
    const newDetails = [...eventDetails];
    newDetails[index][field] = value;
    setEventDetails(newDetails);
  };

  const handleDelete = (index) => {
    const newDetails = eventDetails.filter((_, i) => i !== index);
    setEventDetails(newDetails);
  };

  // const handleAddField = (e) => {
  //   const selected = e.target.value;

  //   // Prevent duplicate category selection
  //   if (
  //     selected &&
  //     selected !== "Custom Field" &&
  //     !eventDetails.some((event) => event.type === selected)
  //   ) {
  //     setEventDetails([...eventDetails, { type: selected, price: "" }]);
  //   } else if (selected === "Custom Field") {
  //     setEventDetails([...eventDetails, { type: "", price: "" }]);
  //   }

  //   setSelectedField(""); // Reset dropdown
  // };

  const handleAddField = (e) => {
    const selected = e.target.value;

    if (
      selected &&
      selected !== "Custom Field" &&
      !eventDetails.some((event) => event.type === selected)
    ) {
      setEventDetails([...eventDetails, { type: selected, price: "" }]);
    } else if (selected === "Custom Field") {
      setEventDetails([
        ...eventDetails,
        {
          type: "Custom Field",
          price: "",
          totalBudgetOptions: [
            "<10000",
            "10000-20000",
            "20000-30000",
            "30000-40000",
            "40000-50000",
            "50000",
          ], // Ensure this is inside the object
        },
      ]);
    }

    setSelectedField(""); // Reset dropdown
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    const formDetails = {
      EventName: formData.eventName,
      Start_Date: formData.startDate,
      End_Date: formData.endDate,
      Description: formData.description,
      Proposed_Date: formData.proposedDate,
      Event_preferences_locations: formData.eventPreferencesLocations,
      email: formData.email,
      mobile_number: formData.mobile_number,
      Guest: formData.guestCount,
      Budget: {
        eventBudget: formData.eventBudget,
        estimatedBudget: totalBudget,
        categories: eventDetails,
      },
      preferences_Language: formData.preferencesLanguage,
    };

    try {
      const accessToken = localStorage.getItem("token");
      if (!accessToken) {
        alert("Access token is missing. Please log in again.");
        navigate("/login");
        return;
      }

      // Now, after a successful POST request, check if data already exists with a GET request
      const getResponse = await axios.get(
        `${BASE_URL}/api/v1/user/budget-tool`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (getResponse.data) {
        // Data already exists, so perform a PUT request to update it
        console.log(formDetails);

        const updateResponse = await axios.put(
          `${BASE_URL}/api/v1/user/budget-tool`,
          formDetails,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        console.log("Budget tool updated successfully:", updateResponse);
      }
      navigate("/user-dashboard", { state: { formDetails } });
    } catch (error) {
      console.error("Error submitting the form:", error);
      alert("Failed to submit the form. Please try again.");
    }
  };

  const convertToNumber = (budgetOption) => {
    // Helper function to convert "L" notation to actual numbers
    const lakhToNumber = (str) => Number(str.replace("L", "")) * 100000;

    // Helper function to convert normal numbers (e.g., "5000-10000")
    const parseNumber = (str) => Number(str.replace(/[^0-9]/g, "")); // Remove non-numeric characters

    if (budgetOption.includes("-")) {
      // Case: Range like "1L-3L" or "5000-10000"
      const [minStr, maxStr] = budgetOption.split("-");
      const min = minStr.includes("L")
        ? lakhToNumber(minStr)
        : parseNumber(minStr);
      const max = maxStr.includes("L")
        ? lakhToNumber(maxStr)
        : parseNumber(maxStr);
      return { min, max, average: (min + max) / 2 };
    } else if (budgetOption.startsWith("<")) {
      // Case: "<1L" or "<5000"
      const value = budgetOption.includes("L")
        ? lakhToNumber(budgetOption.substring(1)) * 0.75 // Assume 75% of 1L
        : parseNumber(budgetOption.substring(1)) * 0.75;
      return { min: value, max: value, average: value };
    } else if (budgetOption.startsWith(">")) {
      // Case: ">5L" or ">30000"
      const value = budgetOption.includes("L")
        ? lakhToNumber(budgetOption.substring(1)) * 1.2 // Assume 120% of 5L
        : parseNumber(budgetOption.substring(1)) * 1.2;
      return { min: value, max: value, average: value };
    } else {
      // Case: Single value like "2L" or "10000"
      const value = budgetOption.includes("L")
        ? lakhToNumber(budgetOption)
        : parseNumber(budgetOption);
      return { min: value, max: value, average: value };
    }
  };

  const totalBudget = eventDetails.reduce(
    (acc, curr) => acc + (convertToNumber(curr.price)?.average || 0),
    0
  );

  const handleSliderChange = (newValue) => {
    setFormData((prev) => ({
      ...prev,
      minBudget: newValue[0],
      maxBudget: newValue[1],
    }));
    console.log("Slider Changed:", newValue);
  };

  const totalBudgetInWords = numberToWords(totalBudget);

  useEffect(() => {
    setTotBudget(formData.eventBudget);
    setBudget(formData.estimatedBudget);
  }, [eventDetails]);

  // console.log(Budget, Number(TotBudget))

  // useEffect(() => {
  //   if (Budget < Number(TotBudget)) {
  //     setIsModalOpen(true);
  //   }
  // }, [Budget, TotBudget]);

  return (
    <div className="container mb-5">
      <div>
        <div className="row align-items-center">
          <div className="centered-container">
            <h2
              className="section-heading"
              data-aos="zoom-in-down"
              data-aos-delay="100"
              data-aos-duration="900"
            >
              Budget planning tool
            </h2>
            <p
              className="section-para text-border"
              data-aos="zoom-in-up"
              data-aos-delay="150"
              data-aos-duration="900"
            >
              "Explore the most enchanting locations for your perfect day and
              Vendors ."
            </p>
          </div>
        </div>
      </div>
      <div>
        <Card id="event-details-card">
          <Card.Body>
            <div className="d-flex  justify-content-end  ">
              <Button variant="secondary" onClick={onClose}>
                X
              </Button>
            </div>
            <Row>
              <Col md={6} style={{ paddingRight: "9%" }}>
                <form>
                  <div data-mdb-input-init className="form-outline mb-4">
                    <label className="form-label" htmlFor="form6Example3">
                      Event Name
                    </label>
                    <input
                      type="text"
                      id="eventName"
                      name="eventName"
                      className="form-control"
                      onChange={handleFormChange}
                      value={formData.eventName}
                    />
                  </div>
                  {/* <div data-mdb-input-init className="form-outline mb-4">
                    <Typography variant="body1" gutterBottom>
                      Total Budget (₹)
                    </Typography>
                    <Slider
                      value={[
                        formData.minBudget || 0,
                        formData.maxBudget || 1000000,
                      ]}
                      onChange={(e, newValue) => handleSliderChange(newValue)}
                      valueLabelDisplay="auto"
                      min={0}
                      max={1000000}
                      step={5000}
                    />

                    <div className="d-flex justify-content-between">
                      <span>Min: ₹{formData.minBudget || 0}</span>
                      <span>Max: ₹{formData.maxBudget || 1000000}</span>
                    </div>
                  </div> */}
                  <div data-mdb-input-init className="form-outline mb-4">
                    <label className="form-label" htmlFor="form6Example3">
                      {" "}
                      Total Number of Guest{" "}
                    </label>
                    <input
                      type="text"
                      id="guestCount"
                      name="guestCount"
                      className="form-control"
                      onChange={handleFormChange}
                      value={formData.guestCount}
                    />
                  </div>
                  <div className="row mb-4">
                    <div className="col">
                      <div data-mdb-input-init className="form-outline">
                        <label className="form-label" htmlFor="form6Example1">
                          {" "}
                          Event Start Date
                        </label>
                        <input
                          type="date"
                          id="startDate"
                          name="startDate"
                          className="form-control"
                          onChange={handleFormChange}
                          value={
                            formData.startDate
                              ? formData.startDate.split("T")[0]
                              : ""
                          }
                          min={new Date().toISOString().split("T")[0]}
                        />
                      </div>
                    </div>
                    <div className="col">
                      <div data-mdb-input-init className="form-outline">
                        <label className="form-label" htmlFor="form6Example2">
                          Event End Date
                        </label>
                        <input
                          type="date"
                          id="endDate"
                          name="endDate"
                          className="form-control"
                          onChange={handleFormChange}
                          value={
                            formData.endDate
                              ? formData.endDate.split("T")[0]
                              : ""
                          }
                          min={new Date().toISOString().split("T")[0]}
                        />
                      </div>
                    </div>
                  </div>
                  <div data-mdb-input-init className="form-outline mb-4">
                    <label className="form-label" htmlFor="form6Example3">
                      Proposed Date
                    </label>
                    <input
                      type="date"
                      id="proposedDate"
                      name="proposedDate"
                      className="form-control"
                      onChange={handleFormChange}
                      value={
                        formData.proposedDate
                          ? formData.proposedDate.split("T")[0]
                          : ""
                      }
                      min={
                        formData.startDate
                          ? formData.startDate.split("T")[0]
                          : ""
                      }
                      max={
                        formData.endDate ? formData.endDate.split("T")[0] : ""
                      }
                    />
                  </div>

                  <div data-mdb-input-init className="form-outline mb-4">
                    <label className="form-label" htmlFor="form6Example3">
                      Event preferences City
                    </label>
                    {/* <input type="text" id="Event_preferences_locations"  name='Event_preferences_locations' className="form-control"  onChange={handleFormChange} value={formData.Event_preferences_locations}/> */}
                    <select
                      className="form-control"
                      id="eventPreferencesLocations"
                      name="eventPreferencesLocations" // ✅ Keep the key as it is
                      value={formData.eventPreferencesLocations || ""} // ✅ Ensure correct access
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          eventPreferencesLocations: e.target.value, // ✅ Update with the correct key
                        }))
                      }
                      required
                    >
                      <option value="">Select Location</option>
                      {locations.map((location, index) => (
                        <option key={index} value={location.LocationName}>
                          {location.LocationName}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div data-mdb-input-init className="form-outline mb-4">
                    <label className="form-label" htmlFor="form6Example3">
                      Optional Email
                    </label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      className="form-control"
                      onChange={handleFormChange}
                      value={formData.email}
                    />
                  </div>

                  <div data-mdb-input-init className="form-outline mb-4">
                    <label className="form-label" htmlFor="form6Example3">
                      Optional Mobile Number{" "}
                    </label>
                    <input
                      type="text"
                      id="mobile_number"
                      name="mobile_number"
                      className="form-control"
                      onChange={handleFormChange}
                      value={formData.mobile_number}
                    />
                  </div>

                  <div data-mdb-input-init className="form-outline mb-4">
                    <label className="form-label" htmlFor="form6Example7">
                      Description
                    </label>
                    <textarea
                      className="form-control"
                      id="description"
                      name="description"
                      rows="4"
                      onChange={handleFormChange}
                      value={formData.description}
                      required
                    ></textarea>
                  </div>

                  <div data-mdb-input-init className="form-outline mb-4">
                    <label
                      className="form-label"
                      htmlFor="preferences_Language"
                    >
                      Event Co-ordinator Preferences Language:
                    </label>
                    {/* <input
                      type="text"
                      id="preferencesLanguage"
                      name="preferencesLanguage"
                      className="form-control"
                      onChange={handleFormChange}
                      value={formData.preferencesLanguage}
                    /> */}

                    <Select
                      isMulti
                      value={(() => {
                        let parsedLanguages;

                        if (Array.isArray(formData.preferencesLanguage)) {
                          parsedLanguages = formData.preferencesLanguage;
                        } else {
                          try {
                            parsedLanguages = JSON.parse(
                              formData.preferencesLanguage
                            );
                          } catch (error) {
                            parsedLanguages = [formData.preferencesLanguage]; // Fallback for plain string
                          }
                        }

                        return parsedLanguages.map((lang) => ({
                          label: lang,
                          value: lang,
                        }));
                      })()}
                      onChange={(selectedOptions) => {
                        setFormData((prev) => ({
                          ...prev,
                          preferencesLanguage: JSON.stringify(
                            selectedOptions
                              ? selectedOptions.map((opt) => opt.value)
                              : []
                          ),
                        }));
                      }}
                      options={[
                        "Hindi",
                        "English",
                        "Marathi",
                        "Tamil",
                        "Telugu",
                        "Bengali",
                      ].map((lang) => ({ label: lang, value: lang }))}
                    />
                  </div>

                  {!isSmallScreen && (
                    <button
                      data-mdb-ripple-init
                      type="button"
                      className="btn btn-primary btn-block mb-4"
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  )}
                </form>
              </Col>
              <Col md={1} className="partition-line"></Col>
              <Col md={5} style={{ marginTop: "2%" }}>
                <Row className="mb-3 align-items-center">
                  <Col>
                    <label>Select Categories</label>
                    <select
                      className="form-control"
                      value={selectedField}
                      onChange={handleAddField}
                      id="select-last"
                    >
                      <option
                        style={{ fontWeight: "bold", marginTop: "7%" }}
                        value=""
                      >
                        Add More Categories
                      </option>
                      {categories
                        .filter(
                          (field) =>
                            field.CategorieName === "WEDDING ENTERTAINMENT" ||
                            !eventDetails.some(
                              (event) => event.type === field.CategorieName
                            ) 
                        )
                        .map((field, index) => (
                          <option
                            style={{ marginBottom: "5%" }}
                            key={index}
                            value={field.CategorieName}
                          >
                            {field.CategorieName}
                          </option>
                        ))}
                      <option value="Custom Field">Custom Field</option>
                    </select>
                  </Col>

                  {/* <Col>
                    <label>Select Categories</label>
                    <select
                      className="form-control"
                      value={selectedField}
                      onChange={handleAddField}
                      id="select-last"
                    >
                      <option
                        style={{ fontWeight: "bold", marginTop: "7%" }}
                        value=""
                      >
                        Add More Categories
                      </option>
                      {categories.map((field, index) => (
                        <option
                          style={{ marginBottom: "5%" }}
                          key={index}
                          value={field.CategorieName}
                        >
                          {field.CategorieName}
                        </option>
                      ))}
                      <option value="Custom Field">Custom Field</option>
                    </select>
                  </Col> */}
                </Row>
                {eventDetails.map((detail, index) => (
                  <CategorySelectionComponent
                    key={index}
                    detail={detail}
                    index={index}
                    categories={categories}
                    handleChange={handleChange}
                    handleDelete={handleDelete}
                  />
                ))}
                ;
                <div className="card mt-5">
                  <div className="card-body">
                    <h5 className="total-budget">
                      Total Budget: ₹{totalBudget.toFixed(2)}
                    </h5>
                    <h5 className="total-budget-words">
                      <span style={{ color: "rgb(238, 74, 101)" }}>
                        In Words:
                      </span>{" "}
                      {totalBudgetInWords}
                    </h5>
                  </div>

                  {/* {Budget >= TotBudget && (
                    <div className="card-body">
                      <h5 className="total-budget">
                        Total Budget: ₹{totalBudget.toFixed(2)}
                      </h5>
                      <h5 className="total-budget-words">
                        <span style={{ color: "rgb(238, 74, 101)" }}>
                          In Words:
                        </span>{" "}
                        {totalBudgetInWords}
                      </h5>
                    </div>
                  )} */}
                </div>
                {isSmallScreen && (
                  <Button
                    variant="dark"
                    style={{ marginTop: "2%", marginLeft: "48%" }}
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>Alert</h3>
              <p>
                Your service cost is out of budget. Please increase your total
                budget.
              </p>
              <button onClick={() => setIsModalOpen(false)}>OK</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpdateEventDetails;
